import { Component, Input } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';

import { PushPipe } from '@ngrx/component';
import { Store } from '@ngrx/store';

import {
  DividerComponent,
  HeadingComponent,
  ProtectedControlDirective,
} from '@recruitee/user-interface';

import { InterviewBaseBoxComponent } from '../interview-base-box/interview-base-box.component';
import { InterviewButtonSelectComponent } from '../interview-button-select/interview-button-select.component';
import { InterviewResultsModule } from '../interview-results.module';

@Component({
  selector: 'rt-interview-scorecard',
  templateUrl: 'interview-scorecard.component.html',
  styleUrls: ['./interview-scorecard.component.less'],
  standalone: true,
  imports: [
    InterviewResultsModule,
    ReactiveFormsModule,
    ProtectedControlDirective,
    HeadingComponent,
    DividerComponent,
    PushPipe,
    InterviewBaseBoxComponent,
    InterviewButtonSelectComponent,
  ],
})
export class InterviewScorecardComponent {
  @Input() public questionForm: UntypedFormGroup;
  @Input() public formSubmissionAttempt: boolean = false;

  constructor(private store: Store) {}

  public getOptionsControls() {
    return <UntypedFormControl[]>(<UntypedFormArray>this.questionForm.get('options')).controls;
  }

  public trackByOption(index: number, option: UntypedFormControl): number {
    return option.value.title;
  }
}
